import script from "./JobView.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobView.vue?vue&type=script&setup=true&lang=ts"

import "./JobView.vue?vue&type=style&index=0&id=3e21feed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e21feed"]])

export default __exports__